import { inject, Injectable } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { IMenuProvider, Menu } from '@maersk-global/angular-shared-library';
import { filter, take } from 'rxjs';
import { RbacService } from './rbac.service';
import { SharedDataService } from './shared-data.service';

@Injectable()
export class SidenavMenuService implements IMenuProvider {

  menuData: Menu[] = [
    {
      displayName: 'Dashboard',
      icon: 'speedometer',
      showLabel: true,
      isSelected: false,
      hidden: false,
      onClick: () => {
        this.router.navigate(['/dashboard']);
      },
      disabled: false
    },
    {
      displayName: 'Shipments',
      icon: 'container-stacked',
      showLabel: true,
      isSelected: false,
      hidden: false,
      onClick: () => {
        this.sharedService.setData(null);
        this.router.navigate(['/shipments']);
      }
    },
    {
      displayName: 'File Upload',
      icon: 'file-copy',
      showLabel: true,
      isSelected: false,
      hidden: true,
      onClick: () => {
        this.router.navigate(['/fileupload']);
      }
    },
    {
      displayName: 'Settings',
      icon: 'cog',
      showLabel: true,
      isSelected: false,
      hidden: false,
      onClick: () => {
        this.router.navigate(['/settings']);
      }
    }
  ];

  private router = inject(Router);
  private sharedService = inject(SharedDataService);
  private rbacService = inject(RbacService);

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof ActivationEnd),
    ).subscribe(() => {
      // menu items rely on Sync Access RBAC state, not the emitted DryUser
      this.sharedService.userRoleCustomers$.pipe(take(1)).subscribe(() => {
        this.handleMenuRBAC();
      });
    });
  }

  private handleMenuRBAC(): void {
    const hasAdminFeatureAccess = this.rbacService.hasAdminFeatureAccess();
    const isGlobalAdmin = this.rbacService.isGlobalAdmin();
    this.menuData.find(item => item.displayName === 'Settings')!.hidden = !hasAdminFeatureAccess;
    this.menuData.find(item => item.displayName === 'File Upload')!.hidden = !isGlobalAdmin;
    if (isGlobalAdmin) {
      this.selectMenuItemByRouter();
    } else if (this.router.url === '/fileupload') {
      this.resetToFirstMenuItem();
    }
    else {
      this.selectMenuItemByRouter();
    }
  }

  private resetToFirstMenuItem(): void {
    this.menuData.forEach(item => item.isSelected = false);
    this.menuData[0].isSelected = true;
    this.router.navigate(['/dashboard']);
  }

  private selectMenuItemByRouter(): void {
    const currentRoute = this.router.url.substring(1).toLowerCase();
    this.menuData.forEach(item => {
      const itemName = item.displayName?.toLowerCase()?.replace(/\s+/g, "") || '';
      item.isSelected = itemName === currentRoute;
    });
  }

  getMenu(): Menu[] {
    return this.menuData;
  }

}
